import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export function SheetFooter({ className, children }: ComponentProps<'div'>) {
  return (
    <div className={twMerge('flex flex-shrink-0 items-center justify-end gap-2 border-t p-6', className)}>
      {children}
    </div>
  )
}
